import { ModelBase } from '../abstract/model-base.model';

/**
 * Un appel d'outil d'un tour de conversation, pour la supervision technique (#877, §9.1).
 *
 * Réservé aux utilisateurs `canViewMonitoring` : le backend omet le bloc pour les
 * autres. Sur une session supprimée logiquement, `arguments` est vidé (`{}`).
 */
export class AgentToolCall extends ModelBase {

    static override CLASS_NAME: string = 'AgentToolCall';

    private _roundIndex!: number;
    private _callIndex!: number;
    private _toolName!: string;
    private _resolvedToolName!: string | null;
    private _arguments!: any;
    private _success!: boolean;
    private _error!: string;
    // creationDate est hérité de ModelBase

    public get roundIndex(): number {
        return this._roundIndex;
    }

    public set roundIndex(value: any) {
        this._setValue('_roundIndex', value, 'integer');
    }

    public get callIndex(): number {
        return this._callIndex;
    }

    public set callIndex(value: any) {
        this._setValue('_callIndex', value, 'integer');
    }

    /** Méta-outil (`search_tools`/`describe_tool`/`call_tool`) ou outil direct. */
    public get toolName(): string {
        return this._toolName;
    }

    public set toolName(value: any) {
        this._setValue('_toolName', value, 'string');
    }

    /** Vrai outil ciblé par `call_tool` (`null` pour les méta-outils). */
    public get resolvedToolName(): string | null {
        return this._resolvedToolName;
    }

    public set resolvedToolName(value: any) {
        this._setValue('_resolvedToolName', value, 'string');
    }

    /** Arguments de l'appel (filtres OData, texte recherché, body d'écriture…). */
    public get arguments(): any {
        return this._arguments;
    }

    public set arguments(value: any) {
        this._setValue('_arguments', value, 'any');
    }

    public get success(): boolean {
        return this._success;
    }

    public set success(value: any) {
        this._setValue('_success', value, 'boolean');
    }

    /** Message d'erreur court (vide si succès). */
    public get error(): string {
        return this._error;
    }

    public set error(value: any) {
        this._setValue('_error', value, 'string');
    }
}
